import './WelcomeFormsV2Modal.css'

import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@sm/wds-react'
import { setSetting } from '../../../../common/services/settings/settings'
import { getUrl, urls } from '../../../../common/utils/urls'
import { getWelcomePopupClosed } from '../../../../common/models/mixpanel'
import { mixpanel } from '../../../../common/services/telemetry/mixpanel'
import DialogMoreCustomization from './images/DialogMoreCustomization.png'
import DialogPreviewDevices from './images/DialogPreviewDevices.png'
import DialogAutoSave from './images/DialogAutoSave.png'
import DialogUnlimitedQuestions from './images/DialogUnlimitedQuestions.png'


const WELCOME_FORM_BUILDER_CONFIG = [{
  src: DialogMoreCustomization,
  header: 'modals:Greater_customization',
  description: 'modals:Greater_customization_description'
}, {
  src: DialogPreviewDevices,
  header: 'modals:Preview_your_form',
  description: 'modals:Preview_your_form_description'
}, {
  src: DialogAutoSave,
  header: 'modals:Auto_save',
  description: 'modals:Auto_save_description'
}, {
  src: DialogUnlimitedQuestions,
  header: 'modals:Unlimited_questions',
  description: 'modals:Unlimited_questions_description'
}]

export let WelcomeFormsV2Modal = props => {
  const { dispatch, t } = props

  // Show "Welcome form builder" modal after this one is dismissed
  setSetting('formBuilder')('welcomeDialogV2Shown', false)

  const handleClose = closeMethod => {
    setSetting('formsV2')('welcomeDialogV2Shown', true)
    dispatch({ type: 'CLOSE_MODAL' })

    const eventDetails = getWelcomePopupClosed('EAP Forms', closeMethod)
    mixpanel.track(eventDetails.event, eventDetails.properties)
  }

  return (
    <Modal
      className='welcome-forms-v2-modal'
      onClose={() => handleClose('Modal Close')}
      show={true}
      size='sm'
    >
      <ModalHeader
        header={(
          <React.Fragment>
            {t('modals:try_the_new_wufoo_form_builder')}
          </React.Fragment>
        )}
      />

      <ModalBody>
        <div className='modal-body-wrapper'>
          {WELCOME_FORM_BUILDER_CONFIG.map(({ src, header, description }, index) => (
            <div className='item' key={index}>
              <img
                className='item-image'
                src={src}
                alt=''
              />
              <div className='item-label'>
                <span className='label-header'>{t(header)}</span>
                <span className='label-description'>{t(description)}</span>
              </div>
            </div>
          ))}
        </div>
      </ModalBody>

      <ModalFooter>
        <Link
          id='welcome-form-builder-get-started'
          onClick={() => handleClose('CTA')}
          to={getUrl(urls.FORM_BUILDER, {})}
        >
          <Button stretched>
            {t('modals:Try_New_Form_Builder')}
          </Button>
        </Link>
      </ModalFooter>
    </Modal>
  )
}

WelcomeFormsV2Modal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

const select = () => ({})

WelcomeFormsV2Modal = connect(select)(WelcomeFormsV2Modal)
WelcomeFormsV2Modal.displayName = 'WelcomeFormsV2Modal'
export default withTranslation('modals')(WelcomeFormsV2Modal)
